import React from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { compareText } from '../comparators/compareText';
import { TextFilter } from '../filters/TextFilter';

export const TextField: FieldComponent<string, string[]> = ({
  intent,
  isActive,
  onChange,
  value,
  hasTooltip,
  disabled,
  mui,
  isMissing,
  forcedValue,
  isAddingNew,
}) => {

  return (
    <>

    </>
  );
};

TextField.includes = (query = [], value = '') => {
  if (query.length === 0 || value === null) return true;
  const valueLowercase = value.toLowerCase();
  return query.some((queryPart) =>
    valueLowercase.includes(queryPart.toLowerCase())
  );
};

TextField.comparator = compareText;

TextField.FilterRenderer = TextFilter;
